import { useState, useEffect } from 'react';

// FIXME:
// devでconsoleにエラー出るので基本的には使用しない方向で消していく
// メディアクエリで代替する
export const useResponsive = () => {
  const isWindowContext = typeof window !== 'undefined';
  const [isDesktop, setDesktop] = useState(
    isWindowContext && window.matchMedia('(min-width: 768px)').matches
  );

  useEffect(() => {
    function screenListener() {
      const type = window.matchMedia('(min-width: 768px)');
      type.addEventListener('change', (e) => {
        if (e.matches) {
          setDesktop(true);
        } else {
          setDesktop(false);
        }
      });
    }
    return screenListener();
  }, []);

  return { isDesktop };
};
